import styled from 'styled-components'

export const EnvPropertiesContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    padding: 74px;

    .info-label{
        margin-top: 10px;
        color: ${({ theme }) => theme['gray-600']};
        @media (min-width: 992px) {
            width: 720px;
            width: 940px;
        }
        @media (min-width: 1600px) {
            width: 1140px;
        }

        .label-env {
            margin-left: 8px;

            span {
                font-weight: 600;
            }
        }
    }
`
